import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const correctiveActionTypesAdapter = getAdapter();

const correctiveActionTypesSlice = createSlice({
  name: 'correctiveActionTypes',
  initialState: correctiveActionTypesAdapter.getInitialState(),
  reducers: {
    setCorrectiveActionTypes: (state, { payload: { correctiveActionTypes } }) => {
      correctiveActionTypesAdapter.setAll(state, correctiveActionTypes);
    },
  },
});

const selectors = correctiveActionTypesAdapter.getSelectors(({ correctiveActionTypes }) => correctiveActionTypes);

export const getCorrectiveActionTypes = (state) => selectors.selectAll(state);

export const {
  setCorrectiveActionTypes,
} = correctiveActionTypesSlice.actions;

export default correctiveActionTypesSlice.reducer;
